<!-- eslint-disable vue/no-multiple-template-root -->
<template>
  <div>
    <el-input
      v-model="short"
      maxlength="6"
      placeholder="请填写6位数验证码"
      @input="getPhoneCode"
    >
    </el-input>
    <el-button type="primary" @click="loginGetCode" :disabled="disabled">{{
      send
    }}</el-button>

    <div class="slide_verify" v-if="captchaVisible">
      <!-- <h4>请完成安全验证</h4> -->
      <!-- <slide-verify
        ref="slideblock"
        @success="onSuccess"
        slider-text="向右滑动完成拼图"
        :imgs="imgs"
        :accuracy="accuracy"
      ></slide-verify> -->
      <captcha ref="captchaRef" :mobile="phone" @ok="onSuccess"></captcha>
    </div>
  </div>
</template>

<script>
import img0 from "@/assets/img/img.jpg";
import img1 from "@/assets/img/img1.jpg";
import img2 from "@/assets/img/img2.jpg";
import img3 from "@/assets/img/img3.jpg";
import img4 from "@/assets/img/img4.jpg";
import img5 from "@/assets/img/img5.jpg";
import { checkVerifyCode } from "../verify-code/constants";
// eslint-disable-next-line no-unused-vars
import captcha from "../verify-code/captcha.vue";
export default {
  components: {
    captcha,
  },
  props: {
    //获取输入的手机号
    phone: {
      type: String,
    },
    // 是否清除
    empty: {
      type: Boolean,
      default: false,
    },
    // 是否禁用按钮
    forbidden: {
      type: Boolean,
      default: false,
    },
    //判断注册不带messageTypeEnum=LOGIN,默认带  false=带  true=不带
    paramsPhoneCode: {
      type: Boolean,
      default: false,
    },
    // 判断是否修改密码
    isExist: {
      type: Number,
      default: 0,
    },
    // 是否需要拖拽验证码
    isCodeShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      short: "",
      disabled: false,
      send: "获取验证码",

      // 拖拽验证码
      isVerifyShow: false,
      imgs: [img0, img1, img2, img3, img4, img5],
      accuracy: 2, // 精确度小，可允许的误差范围小；为1时，则表示滑块要与凹槽完全重叠，才能验证成功。默认值为5
      captchaVisible: false,
    };
  },

  methods: {
    onSuccess(id) {
      // this.isVerifyShow = false;
      // this.$refs.captchaRef.visible = false;
      this.captchaVisible = false;

      this.$api.user
        .getCode({
          codeType: "SIGN_IN",
          expration: 300,
          mobile: this.phone,
          captchaId: id,
        })
        .then((res) => {
          if (res.code == "0") {
            console.log(res);
            let self = this;
            self.disabled = true;
            var time = 60;
            var timer = setInterval(fun, 1000);
            // eslint-disable-next-line no-inner-declarations
            function fun() {
              time--;
              if (time >= 0) {
                self.send = time + "s后刷新";
              } else if (time < 0) {
                self.send = "获取验证码";
                self.disabled = false;
                clearInterval(timer);
                time = 60;
              }
            }
          } else {
            this.$message.error(checkVerifyCode(res.code));
          }
        });
      // this.$api.user.loginGetCodeLogin(this.phone).then((res) => {
      //   console.log("🚀 ~ .then ~ res:", res);
      //   let self = this;
      //   self.disabled = true;
      //   var time = 60;
      //   var timer = setInterval(fun, 1000);
      //   function fun() {
      //     time--;
      //     if (time >= 0) {
      //       self.send = time + "s后刷新";
      //     } else if (time < 0) {
      //       self.send = "获取验证码";
      //       self.disabled = false;
      //       clearInterval(timer);
      //       time = 60;
      //     }
      //   }
      //   if (res.status != "200") {
      //     this.$message.error(res.message);
      //   }
      // });
    },
    //绑定传值
    getPhoneCode(e) {
      this.$emit("changeGetPhoneCode", e);
    },

    //获取验证码
    loginGetCode() {
      // eslint-disable-next-line no-debugger
      console.log(11111);
      var phoneRule = new RegExp(/^1[3-9]\d{9}$/);
      // console.log(phoneRule.test(this.phone))
      if (!this.phone) {
        this.$message.error("请输入手机号");
        return;
      }
      if (!phoneRule.test(this.phone)) {
        this.$message.error("手机号格式不正确");
        return;
      }

      if (this.isExist != 0) {
        console.log(222);
        this.$api.user
          .userPhone({
            mobile: this.phone,
          })
          .then((res) => {
            if (this.isExist == 1) {
              if (res.code == "1") {
                this.getCodeVal();
              } else {
                this.$message.error(res.message);
                return;
              }
            } else {
              if (res.code != "1008") {
                this.$message.error("手机号不存在");
                return;
              } else {
                this.getCodeVal();
              }
            }
          });
      } else {
        console.log(333);
        // this.getCodeVal();
        // this.$refs.captchaRef.visible = true;
        this.captchaVisible = true;
        // this.$refs.captchaRef.openModal();
      }
    },
    getCodeVal() {
      if (this.isCodeShow) {
        // this.isVerifyShow = true;
        // this.$refs.captchaRef.visible = true;
        this.captchaVisible = true;
        return;
      } else {
        this.$api.user.loginGetCodeLogin(this.phone).then((res) => {
          let self = this;
          self.disabled = true;
          var time = 60;
          var timer = setInterval(fun, 1000);
          function fun() {
            time--;
            if (time >= 0) {
              self.send = time + "s后刷新";
            } else if (time < 0) {
              self.send = "获取验证码";
              self.disabled = false;
              clearInterval(timer);
              time = 60;
            }
          }
          if (res.code != 1) {
            this.$message.error(res.message);
          }
        });
      }
    },
  },
  watch: {
    empty: {
      handler(val) {
        if (val) {
          this.short = "";
        }
      },
      immediate: true,
    },
    forbidden: {
      handler(val) {
        this.$set(this, "disabled", val);
      },
      immediate: true,
    },
    isExist: {
      handler(val) {
        if (val && this.phone) {
          this.$api.user
            .userPhone({
              mobile: this.phone,
            })
            .then((res) => {
              if (res.code != "1008") {
                this.disabled = true;
                this.$message.error("手机号不存在");
                return;
              } else {
                this.disabled = false;
              }
            });
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.slide_verify {
  position: fixed;
  /* width: 340px;
  height: 280px; */
  width: 400px;
  /* height: 405px; */
  padding-bottom: 20px;
  z-index: 9999;
  background: #fff;
  top: 57%;
  left: 20%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  border-radius: 5px;
}
.slide_verify h4 {
  font-size: 14px;
  font-weight: normal;
  width: 100%;
  margin-left: 20px;
  /* margin-top: -8px; */
}
.btn {
  margin-top: 20px;
  outline: 0;
  border: none;
  padding: 8px 15px;
  border-radius: 5px;
  color: #fff;
  background-color: #1890ff;
  cursor: pointer;
}
.btn:active {
  box-shadow: 1px 5px 0 rgba(0, 0, 0, 0.1) inset;
}
</style>
